import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
var alignMap = {
  left: 'start',
  center: 'center',
  right: 'end',
  between: 'between',
  around: 'around',
  evenly: 'evenly',
  stretch: 'stretch'
},
    alignValues = Object.keys(alignMap);
export default {
  props: {
    align: {
      type: String,
      validator: function validator(v) {
        return alignValues.includes(v);
      }
    }
  },
  computed: {
    alignClass: function alignClass() {
      var align = this.align === void 0 ? this.vertical === true ? 'stretch' : 'left' : this.align;
      return "".concat(this.vertical === true ? 'items' : 'justify', "-").concat(alignMap[align]);
    }
  }
};